module.exports = "/packs/media/images/autosave_1-cc67694cc3c82e31e070a11a32a014ba.png";